import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss']
})
export class RegisterSuccessComponent implements OnInit {
  user: any;

  constructor() {
    this.user = localStorage.getItem('playerDetails');
    this.user = JSON.parse(this.user);
    window.history.replaceState(null, null, 'successful-registration?registrationSuccess=true&Lang=' + this.user.LanguageID);
  }

  ngOnInit() {

  }

}
